import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
import _imports_0 from './audio-bg.png';
import _imports_1 from '@/assets/discuss/empty.png';
var _hoisted_1 = {
  class: "lesson-show"
};
var _hoisted_2 = {
  key: 0,
  class: "loading-box"
};
var _hoisted_3 = {
  key: 1,
  class: "lesson-content"
};
var _hoisted_4 = ["src", "onClick"];
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "report-name"
};
var _hoisted_7 = {
  key: 0
};
var _hoisted_8 = {
  key: 1
};
var _hoisted_9 = {
  key: 1,
  class: "empty-box empty"
};
var _hoisted_10 = {
  key: 1,
  class: "empty-box empty"
};
import { ref, reactive } from 'vue';
import { MessagePlugin } from 'tdesign-vue-next';
/** 组件 */
import topSearch from './components/topSearch.vue';
import resourcePreview from './components/resourcePreview.vue';
/** 接口 */
import { getTeamWorkByLessonId } from '@/api/index-jiao.js';
import { routeAuth } from '@/utils/auth';
import WujieVue from 'wujie-vue3';
export default {
  __name: 'Show',
  setup: function setup(__props) {
    var bus = WujieVue.bus;
    var pageObj = reactive({
      current: 1,
      size: 40,
      total: 0
    });
    var lessonList = ref([]);
    var isEmpty = ref(false);
    var lessonId = ref(null);
    var showPreview = ref(false);
    var sourceArr = ref([]);
    var loading = ref(false);
    var hasReportsAuth = ref(false);
    /** 事件相关 */
    var geCollAuth = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return routeAuth('classReports');
            case 1:
              hasReportsAuth.value = _context.v;
              if (hasReportsAuth.value) bus.$emit('show-enter-class-report', true);
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              MessagePlugin.error('获取权限异常');
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function geCollAuth() {
        return _ref.apply(this, arguments);
      };
    }();
    geCollAuth();
    /**
     * 展示提交的图片
     * @param {*} item
     * @param {*} type
     */
    var showImg = function showImg(item, fileType) {
      var _item$students;
      if (((_item$students = item.students) === null || _item$students === void 0 || (_item$students = _item$students[0]) === null || _item$students === void 0 ? void 0 : _item$students.fileInfo.fileType) === fileType) {
        return item.students[0].fileInfo.fileUrl;
      }
    };
    var handleSearch = function handleSearch(val) {
      isEmpty.value = !val.dateLength || !val.lessonId;
      if (isEmpty.value) return;
      lessonId.value = val.lessonId;
      getTeamLessonId();
    };
    var getTeamLessonId = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              loading.value = true;
              _context2.p = 1;
              _context2.n = 2;
              return getTeamWorkByLessonId({
                lessonId: lessonId.value,
                current: pageObj.current,
                size: pageObj.size
              });
            case 2:
              res = _context2.v;
              lessonList.value = res.data.data.records;
              pageObj.total = res.data.data.total;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) && MessagePlugin.warning(_t2 === null || _t2 === void 0 ? void 0 : _t2.message);
            case 4:
              _context2.p = 4;
              loading.value = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3, 4, 5]]);
      }));
      return function getTeamLessonId() {
        return _ref2.apply(this, arguments);
      };
    }();
    /**
     * 改变当前页码或每页数据条数
     */
    var changeSizeOrCurrent = function changeSizeOrCurrent(val) {
      pageObj.current = val.current;
      pageObj.size = val.pageSize;
      getTeamLessonId();
    };
    var handlePreview = function handlePreview(item) {
      showPreview.value = true;
      sourceArr.value = item.students;
    };
    return function (_ctx, _cache) {
      var _component_Loading = _resolveComponent("Loading");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_pagination = _resolveComponent("t-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [hasReportsAuth.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(topSearch, {
        class: "top-search",
        onHandleSearch: handleSearch
      }), !isEmpty.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Loading), _cache[3] || (_cache[3] = _createElementVNode("span", null, "加载中...", -1))])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lessonList.value, function (item, index) {
        var _item$students2, _item$students3, _item$students4, _item$students5;
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "lesson-item"
        }, [showImg(item, 10) ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: showImg(item, 10),
          style: _normalizeStyle({
            transform: "rotate(".concat((_item$students2 = item.students) === null || _item$students2 === void 0 || (_item$students2 = _item$students2[0]) === null || _item$students2 === void 0 || (_item$students2 = _item$students2.fileInfo) === null || _item$students2 === void 0 ? void 0 : _item$students2.rotate, "deg) scale(").concat([90, 270].includes(Math.abs((_item$students3 = item.students) === null || _item$students3 === void 0 || (_item$students3 = _item$students3[0]) === null || _item$students3 === void 0 || (_item$students3 = _item$students3.fileInfo) === null || _item$students3 === void 0 ? void 0 : _item$students3.rotate)) ? 0.58 : 1, ")")
          }),
          alt: "",
          class: "report-img",
          onClick: function onClick($event) {
            return handlePreview(item);
          }
        }, null, 12, _hoisted_4)) : _createCommentVNode("", true), showImg(item, 31) ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "report-audio",
          onClick: function onClick($event) {
            return handlePreview(item);
          }
        }, [_cache[4] || (_cache[4] = _createElementVNode("img", {
          src: _imports_0,
          class: "audio-bg",
          alt: ""
        }, null, -1)), _createVNode(_component_svg_icon, {
          name: "play",
          class: "play-icon",
          size: "30"
        })], 8, _hoisted_5)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(item.teamNameExt) + " ", 1), (_item$students4 = item.students) !== null && _item$students4 !== void 0 && (_item$students4 = _item$students4[0]) !== null && _item$students4 !== void 0 && _item$students4.studentName && item.students.length === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString((_item$students5 = item.students) === null || _item$students5 === void 0 || (_item$students5 = _item$students5[0]) === null || _item$students5 === void 0 ? void 0 : _item$students5.studentName) + "  ", 1)) : _createCommentVNode("", true), item.students.length > 1 ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.students.length) + "作品 ", 1)) : _createCommentVNode("", true)])]);
      }), 128))])), _createVNode(_component_t_pagination, {
        modelValue: pageObj.current,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return pageObj.current = $event;
        }),
        pageSize: pageObj.size,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = function ($event) {
          return pageObj.size = $event;
        }),
        total: pageObj.total,
        "show-jumper": "",
        showPageSize: false,
        class: "page-box",
        onChange: changeSizeOrCurrent
      }, null, 8, ["modelValue", "pageSize", "total"])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_svg_icon, {
        name: "empty-icon",
        size: "120",
        class: "icon"
      }), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "empty-text"
      }, "暂无课堂展示内容", -1))]))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_10, _toConsumableArray(_cache[6] || (_cache[6] = [_createElementVNode("img", {
        src: _imports_1,
        alt: ""
      }, null, -1), _createElementVNode("span", null, "暂无应用权限", -1)])))), showPreview.value ? (_openBlock(), _createBlock(resourcePreview, {
        key: 2,
        visible: showPreview.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = function ($event) {
          return showPreview.value = $event;
        }),
        sourceArr: sourceArr.value
      }, null, 8, ["visible", "sourceArr"])) : _createCommentVNode("", true)]);
    };
  }
};